<template>
<el-form :model="formPlan" ref="formPlan" :label-position="'top'">
    <el-form-item label="Selecciona una categoría" prop="idcategory" :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
        ]">
        <el-select v-model="formPlan.idcategory" placeholder="Seleccione" filterable class="w-100" @change="getSubCategorias">
            <el-option v-for="item in listCategorys" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
    </el-form-item>

    <el-form-item label="Selecciona una subcategoría" prop="idsubcategory" :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
        ]">
        <el-select v-model="formPlan.idsubcategory" placeholder="Seleccione" filterable class="w-100" @change="getPlantas">
            <el-option v-for="item in listSubCategorys" :key="item.value" :label="item.text" :value="item.value"></el-option>
        </el-select>
    </el-form-item>

    <div v-if="listPlantas.length>0" class="row">
        <div v-for="(item, index) in listPlantas" :key="index" class="col-sm-4 mb-4">
            <div class="card card-custom">
                <img :src="item.urlImagen" class="card-img-top m-auto">
                <div class="card-body px-2 py-1">
                    <h5 class="card-title d-none" style="color: #606060">{{item.nombre}}</h5>
                    <el-button type="success" round size="small"  icon="el-icon-shopping-cart-2" class="btn-block" @click="agregar(item)">Agregar</el-button>

                    <el-button type="primary" round size="small"  icon="el-icon-zoom-in" class="btn-block ml-0" @click="openDetails(item)">Detalles</el-button>
                </div>
            </div>
        </div>
    </div>


    <div v-else class="">
        <el-alert title="No se encontró productos asociados" type="warning"></el-alert>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="30%" center>
        <span>¿Desea agregar <b>{{item.nombre}}</b> a su carrito de compras?<br>Por favor ingrese la cantidad</span><br>
        <el-input-number v-model="numero" :min="1" :max="20"></el-input-number>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Cancelar</el-button>
            <el-button type="primary" icon="el-icon-shopping-cart-2" @click="addCarrito">Si, agregar</el-button>
        </span>
    </el-dialog>

  <!--popup detalle-->
    <el-dialog title="Detalle" :visible.sync="dialogDetalle" center>
      <!--{{item.nombre}}
      {{item.urlImagenDetalle}}-->
        <img class="m-auto d-block" :src="item.urlImagenDetalle" />
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogDetalle = false">Cerrar</el-button>
        </span>
    </el-dialog>

    <div class="text-right">
        <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formPlan')">Siguiente</button>
    </div>

</el-form>
</template>

<script>
//services
import services from "@/services/services.service";
import moment from "moment";

export default {
    props: {
        club: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data: () => ({
        formPlan: {
            idcategory: null,
            idsubcategory: null
        },
        listCategorys: [],
        listSubCategorys: [],
        listPlantas: [],
        dialogVisible: false,
        dialogDetalle: false,
        numero: 1,
        listCarrito: [],
        item: {}
    }),
    methods: {
        async getCategories() {
            await axios.post(`${process.env.API2}/v1/planta/listarCategoriaPlanta/1`).then((res) => {
                this.listCategorys = res.data
            })
        },

        async getSubCategorias() {
            this.formPlan.idsubcategory = null
            this.listSubCategorys = []
            this.listPlantas = []
            await axios.post(`${process.env.API2}/v1/planta/listarCategoriaPlanta/2/${this.formPlan.idcategory}`).then((res) => {
                this.listSubCategorys = res.data
            })
        },

        async getPlantas() {
            this.listPlantas = []
            await axios.post(`${process.env.API2}/v1/planta/listarPlantaProductoPrecio`, {
                "ue": "001066",
                "sede": "001",
                "categoriaId": this.formPlan.idcategory,
                "productoId": this.formPlan.idsubcategory,
                "areaId": this.club.idseat,
            }).then((res) => {
                this.listPlantas = res.data
            })
        },

        agregar(item) {
            this.item = item
            this.numero = 0
            this.dialogVisible = true
            //this.nombre_planta = item.nombre
        },
        openDetails(item) {
            this.item = item
            this.dialogDetalle = true
        },

        addCarrito() {
            if (this.numero > 0) {
                let tmpcar = {
                    item: (this.listCarrito.length + 1),
                    areaId: "00027",
                    producto: this.item.productoId,
                    codigoPlanta: this.item.plantaId,
                    descripcionProducto: this.item.productoDescripcion,
                    descripcionPlanta: this.item.nombre,
                    precioUnitario: this.item.precioUnitario,
                    cantidad: this.numero,
                    total: (parseFloat(this.item.precioUnitario) * parseInt(this.numero))
                }
                this.listCarrito.push(tmpcar)
                this.$store.dispatch("updateCarrito", this.listCarrito);
                //console.log(this.listCarrito)
            }
            this.dialogVisible = false
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false


                if(this.listCarrito.length>0)
                  this.$emit('resPlanta', this.listCarrito)
                else
                  alert("Su carrito se encuentra vacío, por favor agrege productos a su cesta.")
            })
        },
    },

    created() {
        this.getCategories()
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/plantitas/Producto.vue